import api from './api';
import { Deanery, PaginatedResponse } from '../types';

interface DeaneryFilters {
  search?: string;
  page?: number;
  limit?: number;
}

export const deaneriesService = {
  async getList(filters: DeaneryFilters = {}): Promise<PaginatedResponse<Deanery>> {
    const params = new URLSearchParams();
    
    if (filters.search) params.append('search', filters.search);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    
    const response = await api.get<PaginatedResponse<Deanery>>('/deaneries', { params });
    return response.data;
  },

  async getById(id: number): Promise<Deanery> {
    const response = await api.get<Deanery>(`/deaneries/${id}`);
    return response.data;
  },

  async create(data: Omit<Deanery, 'id' | 'createdAt' | 'updatedAt' | 'temples' | 'coordinator'>): Promise<Deanery> {
    const response = await api.post<Deanery>('/deaneries', data);
    return response.data;
  },

  async update(id: number, data: Partial<Deanery>): Promise<Deanery> {
    const response = await api.put<Deanery>(`/deaneries/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/deaneries/${id}`);
  },

  async setCoordinator(id: number, clergyId: number | null): Promise<Deanery> {
    const response = await api.put<Deanery>(`/deaneries/${id}/coordinator`, { coordinatorId: clergyId });
    return response.data;
  },
};
